module.exports = __webpack_public_path__ + "img/bag-sale.06d82d9a.svg";